import { render } from "./PosView.vue?vue&type=template&id=549341ce&scoped=true"
import script from "./PosView.vue?vue&type=script&lang=js"
export * from "./PosView.vue?vue&type=script&lang=js"

import "./PosView.vue?vue&type=style&index=0&id=549341ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549341ce"]])

export default __exports__